import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Leader {
  name: string;
  api_token: string;
}

export interface LeaderDetaiInfor {
  errors: unknown;
  leader: Leader;
  isAuthenticated: boolean;
}

@Module
export default class LeaderDetail
  extends VuexModule
  implements LeaderDetaiInfor
{
  errors = {};
  leader = {} as Leader;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get LeaderDetail() {
    return this.leaderDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.LEADER_DETAIL_DATA](Leader) {
    this.leaderDetailData = Leader;
  }
  @Action
  [Actions.LEADER_DETAIL](payload) {
    return ApiService.getDataDetail("/leaders", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.LEADER_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
